import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { EndPoint } from '../config/endpoint';
import { HttpService } from './http.service';
@Injectable({
  providedIn: 'root',
})
export class AcademicYearService {
  // BehaviorSubject to track school change events (default: false)
  private schoolChangedSource = new BehaviorSubject<boolean>(false);

  // Observable to subscribe for school change updates
  schoolUpdate$ = this.schoolChangedSource.asObservable();

  // BehaviorSubject to track when a new academic year is added (default: false)
  private newAcademicAdded = new BehaviorSubject<boolean>(false);

  // Observable to subscribe for new academic year updates
  newAcademicYear$ = this.newAcademicAdded.asObservable();

  // BehaviorSubject to control the state of academic year header (default: false)
  disableAcademicHeader = new BehaviorSubject<boolean>(false);

  // BehaviorSubject to control the state of school header (default: false)
  disableSchoolHeader = new BehaviorSubject<boolean>(false);
  /**
   * Emit an update when the school is changed from the header
   * @param isSchoolChanged - flag indicating if school is changed
   */
  emitSchoolUpdateFromHeader(isSchoolChanged: boolean) {
    this.schoolChangedSource.next(isSchoolChanged);
  }

  /**
   * Emit an update when a new academic year is added
   * @param isNewAcademicYear - flag indicating if a new academic year is added
   */
  emitNewAcademicYear(isNewAcademicYear: boolean) {
    this.newAcademicAdded.next(isNewAcademicYear);
  }

  constructor(private httpService: HttpService) {}

  async getAcademicYearDataBySchoolId(queryParams: object) {
    try {
      const response = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.get_academic_year_data_by_school_id}`, {
          params: queryParams,
        }),
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  async updateUserAddedAcademicYearFlag(data: any): Promise<any> {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(
          `${environment.XANO_SERVER_URL}${EndPoint.update_multiple_user_academic_year_highlights_by_school_id}`,
          data,
        ),
      );
      return response;
    } catch (error) {
      console.error('Error updating user academic year flag:', error);
    }
  }
}
